module.exports = __webpack_public_path__ + "static/media/cow.e4a05d7e.svg";